import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Section";
import api from "@/lib/api";

export default function Locations() {
  const [locations, setLocations] = useState([]);
  useEffect(() => { api.get("/locations").then((r) => setLocations(r.data)).catch(() => {}); }, []);
  return (
    <PublicLayout>
      <Seo title="Our Locations in Karnataka" description="Dreamzz HR & Consultancy serves Chikkamagaluru, Kadur, Bengaluru, Hassan, Shivamogga, Mysuru, Mangaluru, Udupi and more across Karnataka." />
      <PageHeader eyebrow="Where We Operate" title="Locations We Serve" subtitle="Locally rooted recruitment and staffing across Karnataka's key towns and cities." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {locations.map((l, i) => (
          <Reveal key={l.slug} delay={i * 25}>
            <Link to={`/locations/${l.slug}`} data-testid={`location-${l.slug}`} className="group glass card-hover rounded-2xl p-6 h-full block">
              <div className="flex items-center gap-2 text-brand-emerald"><MapPin size={18} /><span className="font-display font-semibold text-lg group-hover:text-brand-emerald">{l.name}</span></div>
              <div className="text-xs text-slate-500 mt-1">{l.district}</div>
              <p className="text-sm text-slate-400 mt-3 line-clamp-3">{l.intro}</p>
            </Link>
          </Reveal>
        ))}
      </section>
    </PublicLayout>
  );
}
